import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const TaxService = {
  getList: async (includeInactive = false) => {
    try {
      const response = await apiService.get("/taxtype", {
        params: { includeInactive },
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching tax types:", error);
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await apiService.post("/taxtype", data, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating tax type:", error);
      throw error;
    }
  },

  getDetail: async (id) => {
    try {
      const response = await apiService.get(`/taxtype/${id}`, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching tax type detail:", error);
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await apiService.put(`/taxtype/${id}`, data, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating tax type:", error);
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await apiService.delete(`/taxtype/${id}`, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error deleting tax type:", error);
      throw error;
    }
  },

  getProductTaxes: async (productId) => {
    try {
      const response = await apiService.get(`/taxtype/product/${productId}`, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching product taxes:", error);
      throw error;
    }
  },

  assignProductTax: async (data) => {
    try {
      const response = await apiService.post("/taxtype/product/assign", data, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error assigning product tax:", error);
      throw error;
    }
  },

  removeProductTax: async (productTaxTypeId) => {
    try {
      const response = await apiService.delete(`/taxtype/product/${productTaxTypeId}`, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error removing product tax:", error);
      throw error;
    }
  },

  getOrganizationConfig: async () => {
    try {
      const response = await apiService.get("/taxtype/organization-config", {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching tax organization config:", error);
      throw error;
    }
  },

  updateOrganizationConfig: async (data) => {
    try {
      const response = await apiService.post("/taxtype/organization-config", data, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating tax organization config:", error);
      throw error;
    }
  },
};

export default TaxService;
